const route = {
	path: ':codeUser/assign',
	name: 'page-app-user',
	meta: {
		title: 'Asignar Apps',
	},
	props: true,
	component: () => import('@/pages/users/page-app-user'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/users-apps.js